<ng-container *ngIf="path.length">
  <a
    [routerLink]="path"
    class="text-sm md:text-base"
    [style]="{ textAlign: align }"
  >
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </a>
</ng-container>

<ng-container *ngIf="!path.length && !itemClick.observed">
  <a
    [href]="href"
    target="_blank"
    class="text-sm md:text-base"
    [style]="{ textAlign: align }"
  >
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </a>
</ng-container>

<ng-container *ngIf="itemClick.observed">
  <p
    class="text-sm md:text-base"
    (click)="itemClick.emit()"
    role="button"
    tabindex="0"
    (keydown.enter)="itemClick.emit()"
    (keydown.space)="itemClick.emit()"
  >
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </p>
</ng-container>

<ng-template #content>
  <ng-content></ng-content>
</ng-template>
